export default "__VITE_ASSET__cb65d198__"